var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1e619fc510a3dcf6e505a99ccd0ef39529638f5a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["myody-vue@kompeito"]={id:"1e619fc510a3dcf6e505a99ccd0ef39529638f5a"};
      